import { betActions } from '../../actions';

const { bet, history } = betActions;

const soundsMap = {
  [bet.set.type]: {
    soundName: 'click',
    spriteName: 'base_sprite',
  },
  [bet.rebet.type]: {
    soundName: 'click',
    spriteName: 'base_sprite',
  },
  [bet.double.type]: {
    soundName: 'click',
    spriteName: 'base_sprite',
  },
  [history.pop.type]: {
    soundName: 'cancel',
    spriteName: 'base_sprite',
  },
  [bet.clear.type]: {
    soundName: 'cancel',
    spriteName: 'base_sprite',
  },
};

export default soundsMap;
